export const locale = {
  title: 'You are viewing messages for:',
  records: 'Messaging for Family Members',
};
